
import { useLocation  } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useContext} from 'react'
import systemContext from '../../AppState/SystemConfig/appContext';
import { useEffect,useState } from 'react';
import TokenValidateDialog from './tokenValidateDialog.jsx';
import { Box } from '@mui/material';


function  UserAccess() {
    const {search}= useLocation()
    const navigate = useNavigate();
    const {AppManager} =useContext(systemContext);
    const [validated, setValidated] = useState(false);
    const [isLoading, setisLoading ] = useState(false);


    prompt.setPerfil = (arry) => {
    setisLoading(false)
  
     if(arry!==""){
        setValidated(true)
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
     }else{
        setValidated(false)
        setTimeout(() => {
            navigate("/login");
          }, 3000);
     }
      };



    useEffect(() => {
        if(search){
            const queryParams = new URLSearchParams(search);
    
            // Obtener el valor del parámetro "token" de los query params
            const token = queryParams.get('token');    
            AppManager.setToken(token)  
            AppManager.setQrLogin()  
           
            if (!AppManager.loadingProfile) {
                if(!isLoading){
                    setisLoading(true)
                }
                AppManager.loadProfile(prompt);
              }
        }

        return () => {
            // cleanup
            setValidated(false)
        }
    }, [AppManager,search,navigate,isLoading]);

    return (      

        <Box>
        <TokenValidateDialog validated={validated} isloading={isLoading}></TokenValidateDialog>
        </Box>
    )
}

export default  UserAccess;